import { setDataToLocalStorage } from 'utils';

import { IS_DEBUG_MODE } from './modules/analytics/constants';

const initGlobalMethods = () => {
  if (typeof window !== 'undefined') {
    window.enableCueAnalyticsLogs = () => {
      setDataToLocalStorage(IS_DEBUG_MODE, true);
      // eslint-disable-next-line no-console
      console.info(
        'cue analytics logs are enabled for console. Please refresh to see the changes.',
      );
    };
    window.disableCueAnalyticsLogs = () => {
      setDataToLocalStorage(IS_DEBUG_MODE, false);
      // eslint-disable-next-line no-console
      console.info('cue analytics logs are disabled. Please refresh to see the changes.');
    };
  }
};

export { initGlobalMethods };
